import React, { Component } from 'react';
import { stringFormatter } from '../../utils';
import { t } from '../../locales';
import { TIMECOUNT } from '../../constants/constants';
import VerificationCodeInput from '../VerificationCodeInput';

import './style.scss';

interface VerificationCodeProps {
  newContact?: string;
  length?: number;
  onValidate?: (value: string) => void;
  onReSend?: (params?: any) => void;
  errorMsg?: string;
  text?: string;
}

interface VerificationCodeState {
  otp: string;
  seconds: number;
}

class VerificationCode extends Component<
  VerificationCodeProps,
  VerificationCodeState
> {
  static defaultProps = {
    length: 6,
  };

  private autoCount: any;
  state = {
    otp: '',
    seconds: 60,
  };

  componentDidMount() {
    this.autoPlayTime();
  }

  componentWillUnmount() {
    clearTimeout(this.autoCount);
  }

  autoPlayTime() {
    const { seconds } = this.state;
    this.autoCount = setTimeout(() => {
      this.autoPlayTime();
    }, 1000);
    if (seconds <= 0) {
      clearTimeout(this.autoCount);
    } else {
      this.setState({ seconds: seconds - 1 });
    }
  }

  handleOnChange = (value: string) => {
    this.setState({ otp: value }, () => {
      const { length, onValidate } = this.props;
      if (value && value.length === length) {
        onValidate(value);
      }
    });
  };

  resend() {
    const { onReSend } = this.props;
    this.setState({ seconds: TIMECOUNT }, () => {
      this.autoPlayTime();
    });
    onReSend && onReSend();
  }

  render() {
    const { length, errorMsg, text, newContact } = this.props;

    const { seconds } = this.state;
    return (
      <div className="emma-verification-code">
        <div className="emma-verification-code-title content-align">
          {stringFormatter(t('OTP_ENTER_CODE'), {
            length: `${length}`,
          })}
        </div>
        {newContact && (
          <div className="emma-verification-code-contact content-align">
            {newContact}
          </div>
        )}
        <div className="emma-verification-code-desc content-align">
          {stringFormatter(text ? text : t('OTP_TEXT'), {
            length: `${length}`,
          })}
        </div>
        <div className="emma-verification-code-ul content-align">
          <VerificationCodeInput
            value={this.state.otp}
            valueLength={this.props.length}
            handleOnChange={this.handleOnChange}
          />
        </div>
        {errorMsg && (
          <div className="emma-verification-code-error content-align">
            {errorMsg}
          </div>
        )}
        <div className="emma-verification-code-bottom content-align">
          <div className="emma-verification-code-bottom-span">
            {t('OTP_DOT_NOT_GET_CODE')}
          </div>
          <div className="emma-verification-code-bottom-seconds">
            {seconds === 0 ? (
              <span
                className="emma-verification-code-bottom-resend"
                data-enable-ga
                data-ga-type="button"
                onClick={() => this.resend()}
              >
                {t('OTP_RESEND')}
              </span>
            ) : (
              `${seconds}s`
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default VerificationCode;
